/* eslint-disable react/jsx-props-no-spreading */
import { FormControl, FormHelperText } from '@mui/material';
import { DatePickerProps as DesktopDatePickerProps, DesktopDatePicker } from '@mui/x-date-pickers';
import React from 'react';
import { Controller, useController, useFormContext } from 'react-hook-form';

import { formatServerDate } from '../../util/helpers';

// TODO:
// - write unit tests for this component
interface DatePickerProps extends DesktopDatePickerProps<Date> {
  rules?: any;
  disabled?: boolean;
  fullWidth?: boolean;
  name: string;
  label: string;
  sx?: any;
  minDate?: any;
  maxDate?: any;
  customFormatter?: Function;
  variant?: 'filled' | 'standard' | 'outlined';
  size?: 'small' | 'medium';
}

// The date picker works with a native JS Date object, and JS Date objects uses the local time/timezone.
function DatePicker(props: DatePickerProps) {
  const {
    rules,
    label,
    disabled = false,
    name,
    fullWidth = false,
    sx,
    minDate,
    maxDate,
    customFormatter = formatServerDate,
    variant = 'standard',
    size = 'small',
    ...rest
  } = props;

  const { control } = useFormContext();
  const {
    fieldState: { error },
  } = useController({ name });

  return (
    <FormControl fullWidth={fullWidth}>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field }) => (
          <DesktopDatePicker
            {...field}
            label={label}
            value={customFormatter(field.value) || null}
            onChange={(newValue) => field.onChange(customFormatter(newValue))}
            minDate={customFormatter(minDate)}
            maxDate={customFormatter(maxDate)}
            sx={sx}
            disabled={disabled}
            {...rest}
            slotProps={{ ...rest.slotProps, textField: { variant, size } }}
          />
        )}
      />
      {error?.message && <FormHelperText error={!!error}>{error?.message ? error?.message : ` `}</FormHelperText>}
    </FormControl>
  );
}

export default DatePicker;
